import { useLocation } from "react-router-dom";

import { useUploadQueue } from "../contexts/UploadQueue";
import {
  buildAdvertisingVideoScopeId,
  getCurrentJobForScope,
} from "../contexts/uploadQueueReducer";

import type { UploadJob } from "../contexts/uploadQueue.types";

export interface UseAdvertisingVideoUploadResult {
  job: UploadJob | undefined;
  onSelectFile: (file: File) => void;
  onRetry: () => void;
}

export function useAdvertisingVideoUpload({
  campaignUuid,
  languageUuid,
  projectSlug,
}: {
  campaignUuid: string;
  languageUuid: string;
  projectSlug: string;
}): UseAdvertisingVideoUploadResult {
  const { jobs, enqueue, retry } = useUploadQueue();
  const location = useLocation();

  const job = getCurrentJobForScope(
    jobs,
    buildAdvertisingVideoScopeId(campaignUuid, languageUuid),
  );

  return {
    job,
    onSelectFile: (file: File): void => {
      enqueue(file, {
        kind: "advertisingVideo",
        campaignUuid,
        languageUuid,
        projectSlug,
        navigatePath: location.pathname,
      });
    },
    onRetry: (): void => {
      if (job?.status === "error") retry(job.id);
    },
  };
}
